import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import HelmetManager from './../HelmetManager'
import Image from './../Image'
import bemClass from './../../utils/bemClass'
import prettyText from './../../utils/prettyText'
import api from './../../api'
import './InfoPage.css'

const cn = bemClass('InfoPage')

class InfoPage extends PureComponent {
    state = { data: {} }

    getApi = async site => {
        const data = await api(`page/${site}`)

        this.setState({ data })
    }

    parseParagraphs = (paragraphs, className) =>
        paragraphs &&
        paragraphs
            .split('\n')
            .map((paragraph, key) => (
                <p
                    key={key}
                    className={className}
                    dangerouslySetInnerHTML={prettyText(paragraph)}
                />
            ))

    componentWillMount() {
        const { site } = this.props.match.params

        this.getApi(site)
    }

    componentWillReceiveProps(nextProps) {
        const { site } = nextProps.match.params

        if (site === this.props.match.params.site) {
            return
        }

        this.getApi(site)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    renderGallery = () => {
        const { data } = this.state

        const galleryKeys = [
            'gallery1',
            'gallery2',
            'gallery3',
            'gallery4',
            'gallery5',
        ]

        return galleryKeys.map(
            key =>
                !!data[key] ? (
                    <Image
                        src={data[key]}
                        className={cn('gallery-image')}
                        alt={`${data.title} - ${key}`}
                    />
                ) : null
        )
    }

    render() {
        const { className } = this.props
        const { data } = this.state

        if (!Object.keys(data).length) {
            return null
        }

        const {
            title,
            description,
            image,
            ticketInfo,
            ticketLink,
            ticketLinkCaption,
            dateString,
            hour,
        } = data

        const dateAndHour = `${dateString ? dateString : ''}${
            !!hour ? `<br/>${hour}` : ''
        }`

        return (
            <div className={`${cn()} ${className}`}>
                <h1
                    className={cn('header')}
                    dangerouslySetInnerHTML={prettyText(title)}
                />
                {this.parseParagraphs(description, cn('paragraph'))}
                <div className={cn('description')}>
                    {dateAndHour && (
                        <span
                            dangerouslySetInnerHTML={prettyText(dateAndHour)}
                        />
                    )}
                    {ticketInfo &&
                        this.parseParagraphs(ticketInfo, cn('ticket-info'))}
                    {ticketLink && (
                        <a
                            className={cn('buy-ticket')}
                            href={ticketLink}
                            target="_blank"
                        >
                            {ticketLinkCaption || 'Bilety'}
                        </a>
                    )}
                </div>
                {image && (
                    <Image src={image} className={cn('image')} alt={title} />
                )}
                {this.renderGallery()}
                <HelmetManager
                    title={title}
                    description={description}
                    image={image}
                />
            </div>
        )
    }
}

InfoPage.propTypes = {
    className: PropTypes.string,
    match: PropTypes.object,
}

InfoPage.defaultProps = {
    className: '',
    match: { params: {} },
}

export default InfoPage



// WEBPACK FOOTER //
// ./src/components/InfoPage/InfoPage.jsx